import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import BriefDetails from "../components/BriefDetails";

function AdminElectionDetails() {
  const [constituencies, setConstituencies] = useState([]);
  const [assemblies, setAssemblies] = useState([]);
  const [selectedConstituency, setSelectedConstituency] = useState(null);
  const [selectedAssembly, setSelectedAssembly] = useState(null);

  const handleConstituencySelect = async (value) => {
    setSelectedConstituency(value);
    setSelectedAssembly(null);
    setAssemblies([]);

    setSelectedConstituency(value);
    const response = await dataService.getAssemblyFromConstituency(value);
    setAssemblies(response.data);
  };

  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) setConstituencies(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getConstituency();
  }, []);

  return (
    <BriefDetails
      title={<span style={{ fontSize: "24px", fontWeight: "bold" }}>Constituency Details</span>}
      primaryDropdownLabel="Select Constituency"
      primaryDropdownData={constituencies}
      primaryDropdownValue={selectedConstituency}
      onPrimarySelect={handleConstituencySelect}
      secondaryDropdownLabel="Select Assembly"
      secondaryDropdownData={assemblies}
      secondaryDropdownValue={selectedAssembly}
      onSecondarySelect={setSelectedAssembly}
      hasSecondaryDropdown={true}
      id={selectedAssembly}
    />

  );
}

export default AdminElectionDetails;
